import '../App.css';
import { useEffect, useState } from 'react'
import { Dialog, DialogPanel, DialogTitle } from '@headlessui/react'
import { GoCircle } from 'react-icons/go'
import { SlLocationPin } from 'react-icons/sl'
import { RiWeightLine } from 'react-icons/ri'
import { MdDirectionsBike } from 'react-icons/md'
import { FcBusinessman } from "react-icons/fc";
import { API_URL, RETURN_URL_BIKE } from '../config.js';
import { CANCEL_COURIER, UPDATE_ORDER } from '../graphql/Mutation/SameDayOrder.js';
import { useMutation } from '@apollo/client';
import { toast } from 'react-toastify';
import { cashfree } from '../utils/CashFreePayment.js';
import SpinLoader from '../components/SpinLoader.js';
import Swal from 'sweetalert2'
import PriceCalculator from '../DocumentShiping/priceCalculator.js';


export default function Findbikemodels({ open, showData, setOpen }) {
    // console.log('✌️showData --->', showData);
    const [driverInfo, setDriverInfo] = useState();
    const [cancelCourier] = useMutation(CANCEL_COURIER);
    const [updateCourier] = useMutation(UPDATE_ORDER);
    // const TIMER_DURATION = 240; // Timer duration in seconds (4 minutes)
    const TIMER_DURATION = 5 * 60; // 5 minutes in seconds
    const SEARCH_DURATION = 10 * 60;
    const POLLING_INTERVAL = 25000;
    const [remainingTime, setRemainingTime] = useState(SEARCH_DURATION);

    const [timer, setTimer] = useState(null); // Timer state in seconds
    // Timer logic
    useEffect(() => {
        let timerInterval;
        if (timer > 0) {
            timerInterval = setInterval(() => {
                setTimer((prevTimer) => prevTimer - 1);
            }, 1000);
        } else if (timer === 0) {
            clearInterval(timerInterval);
            // console.log("Timer ended. Payment session expired.");
        }

        return () => clearInterval(timerInterval);
    }, [timer]);

    useEffect(() => {
        let timerIntervalData;

        if (remainingTime > 0 && !driverInfo) {
            // Start the timer if remainingTime is positive and no driver is found yet
            timerIntervalData = setInterval(() => {
                setRemainingTime((prevTime) => prevTime - 1);
            }, 1000);
        }

        if (driverInfo) {
            // Stop the timer if driverInfo is available
            clearInterval(timerIntervalData);
        }

        if (remainingTime === 0 && !driverInfo) {
            // Cancel order when timer expires and no driver is found
            clearInterval(timerIntervalData);
            setOpen(false);
            cancelCourier({ variables: { orderId: showData?.addOrderForSameDay?.order_id } })
                .then(() => {
                    toast.error("Driver not assigned in time. Order cancelled. Please try again.");
                })
                .catch((err) => {
                    console.error("Failed to cancel Shipment:", err.message);
                });
        }

        return () => clearInterval(timerIntervalData);
    }, [remainingTime, driverInfo]);


    useEffect(() => {
        let intervalId; // To store the interval ID for stopping it later

        const trackShipment = async () => {
            const order_id = showData?.addOrderForSameDay?.order_id;
            if (!order_id) return;

            try {
                const response = await fetch(`${API_URL}/api/orders/${order_id}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }

                const data = await response.json();
                // console.log('✌️datauuuuuuuuu', data);
                if (data?.status === "cancelled") {
                    clearInterval(intervalId);
                    //     updateCourier({
                    //         variables: {
                    //             "input": {
                    //                 "status": data?.status,
                    //                 "order_accepted_time": data?.order_timings?.order_accepted_time,
                    //                 "id": showData?.addOrderForSameDay?.id
                    //             }
                    //         }
                    //     })
                }
                if (data?.status === 'accepted' && data?.partner_info) {
                    setDriverInfo(data)
                    await updateCourier({
                        variables: {
                            "input": {
                                "status": data?.status,
                                "order_accepted_time": data?.order_timings?.order_accepted_time,
                                "id": showData?.addOrderForSameDay?.id,
                                "pymentOrder": false,
                                "driverInfo": data?.partner_info
                            }
                        }
                    })
                    // console.log('Partner Info:', data.partner_info);

                    setTimer(TIMER_DURATION);
                    // Stop further API calls once partner_info is available

                    clearInterval(intervalId);
                }
            } catch (err) {
                // console.log('✌️err --->', err);
            }
        };

        intervalId = setInterval(trackShipment, 25000);

        // Cleanup interval on component unmount
        return () => clearInterval(intervalId);
    }, [showData?.addOrderForSameDay?.order_id]);

    const handleCancelOrder = () => {
        Swal.fire({
            title: "Are You Sure You Want to Cancel Your Shipment and Not Find Driver?",
            html: `<p class="swal-professional-text">
                      Are you sure you want to cancel your Shipment? Once cancelled, the assigned driver will be unlinked, 
                      and the delivery process will stop immediately. If you’re certain, please click the 'Cancel Shipment'
                      button below to confirm your cancellation. Alternatively, if you wish to proceed with the delivery, 
                      simply close this message or click 'Find Driver' to reassign a driver and continue with the delivery process. 
                      If you have any questions, feel free to contact us for assistance.
                    </p>`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#1F2937",  // Dark gray color for a professional feel
            cancelButtonColor: "#B8B8B8",   // Lighter color for the cancel button
            confirmButtonText: "Yes, cancel it!",
            cancelButtonText: "No, keep it",
            customClass: {
                title: "swal-professional-title",
                text: "swal-professional-text",
                confirmButton: "swal-professional-button",
                cancelButton: "swal-professional-button",
                icon: "swal-professional-icon"
            },
            backdrop: true,
            // padding: '30px',
            showClass: {
                popup: 'animate__animated animate__zoomIn',
            },
            hideClass: {
                popup: 'animate__animated animate__zoomOut',
            }
        }).then((result) => {
            if (result.isConfirmed) {
                cancelorder();
            }
        });
    };

    const cancelorder = async () => {
        await cancelCourier({ variables: { orderId: showData?.addOrderForSameDay?.order_id } })
            .then(async ({ data }) => {
                // Swal.fire({
                //     title: "Cancelled!",
                //     text: "Your order has been cancelled successfully.",
                //     icon: "success",
                //     confirmButtonColor: "#3085d6",

                // });

                setOpen(false);
                toast.success("Order Cancelled successfully!", { autoClose: 2000 });
            })
            .catch((err) => {
                // Swal.fire({
                //     timer: 2000,
                //     // showConfirmButton: false,
                //     title: "Error!",
                //     text: err.message || "Something went wrong. Please try again.",
                //     icon: "error",
                //     confirmButtonColor: "#d33",

                // });

                toast.error(err?.message, { autoClose: 2000 });

            });
    };

    const paymentOrder = () => {
        updateCourier({
            variables: {
                "input": {
                    "status": driverInfo?.status,
                    "id": showData?.addOrderForSameDay?.id,
                    "pymentOrder": true,
                    "driverInfo": driverInfo?.partner_info
                }
            }
        }).then(async ({ data }) => {
            // console.log('✌️data --->', data);
            if (data?.updateOrderForSameDay?.paymentSessionId && data?.updateOrderForSameDay?.status === 'accepted') {

                const paymentSessionId = data?.updateOrderForSameDay?.paymentSessionId;
                const checkoutOptions = {
                    paymentSessionId,
                    "return_url": RETURN_URL_BIKE,
                    redirectTarget: "_self",
                };
                cashfree.checkout(checkoutOptions)
            }
        })
            .catch((err) => {
                toast.error(err.message, { autoClose: 2000 });
            });
    }

    return (
        <Dialog open={open} onClose={() => { }} className="relative z-50">
            <div
                transition
                className="fixed inset-0 bg-black bg-opacity-75 transition-opacity"
            />

            <div className="fixed inset-0 z-50 w-screen overflow-y-auto">
                <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
                    <DialogPanel
                        transition
                        className="relative w-full max-h-screen overflow-y-auto transform rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg lg:max-w-xl xl:max-w-2xl 2xl:max-w-7xl">
                        <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4 space-y-5">
                            <div>
                                <p className='text-xl mb-5 font-bold'>Shipping Partner Details</p>
                                <p className='border border-slate-100'></p>
                            </div>

                            {/* <div className="flex items-center justify-center min-h-screen bg-gradient-to-r from-blue-500 to-purple-600"> */}
                            <div className="max-w-full sm:max-w-4xl w-full bg-white rounded-xl lg:ps-4 flex flex-col lg:flex-row items-center lg:space-x-10 space-y-8 sm:space-y-0">
                                {/* Booking Done Status */}
                                <div className="flex-shrink-0 md:my-6 my-0 lg:my-0 mt-4 relative">
                                    {/* Outer circle animation (small size) */}
                                    {driverInfo?.partner_info && driverInfo?.partner_info?.name ? <></> : <div className="absolute inset-0  w-56  h-56 bg-blue-200 rounded-full animate-ping"></div>}
                                    {/* Icon container */}
                                    <div className={`relative w-56 h-56 ${timer === 0 ? 'bg-red-500' : driverInfo?.partner_info ? 'bg-green-500 h-56 w-56' : 'bg-blue-100'}
 rounded-full flex items-center justify-center transform transition-all duration-300 hover:scale-105 cursor-pointer`}>
                                        {/* Replace FcBusinessman with any desired icon */}
                                        <FcBusinessman className="text-9xl" />
                                    </div>
                                </div>
                                {/* Booking Details */}
                                <div className="flex-1 text-left">
                                    {/* <h2 className="text-lg font-semibold text-gray-800">
                                        Booking Done <span className="text-green-500">&#10004;</span>
                                    </h2> */}
                                    {driverInfo?.partner_info ? <></> : <p className="text-md text-gray-600 mt-3 font-semibold">
                                        Searching for a <span className="font-bold">driver... {Math.floor(remainingTime / 60)}:{(remainingTime % 60).toString().padStart(2, "0")} minutes.</span>
                                    </p>}
                                    <p className="text-xs text-slate-500 mt-1">Your booking will be automatically cancelled if a driver is not allocated within 10 minutes. Once a driver is successfully assigned, a prepaid payment is mandatory to confirm the order. If the payment is not made, the order will be cancelled.
                                        <span className="font-semibold text-lg text-green-600"> {timer !== null && timer > 0 && (
                                            <div>
                                                <p>
                                                    Complete your payment within:{" "}
                                                    <p className='semibold'>{Math.floor(timer / 60)}:{(timer % 60).toString().padStart(2, "0")} minutes.</p>
                                                </p>
                                            </div>
                                        )}</span>
                                    </p>

                                    {timer === 0 && (
                                        <div className="text-red-500 font-semibold my-3">
                                            <p>Session Expired:</p>
                                            <p>Order Canceled. Please Try Again.</p>
                                        </div>
                                    )}
                                    {/* <p className="text-xs text-gray-500 mt-1">
                                        {driverInfo?.partner_info?.name}
                                    </p> */}
                                    {/* <p className="text-xs text-gray-500 mt-1">
                                        {driverInfo?.partner_info?.vehicle_type} : {driverInfo?.partner_info?.vehicle_number}
                                    </p> */}
                                    {/* <p className="text-xs text-gray-500 mt-1"> */}
                                    {/* {driverInfo?.partner_info?.mobile?.country_code}{driverInfo?.partner_info?.mobile?.mobile_number}
                                    </p>
                                    <p className="text-xs text-gray-500 mt-1">
                                        {driverInfo?.partner_info?.partner_secondary_mobile?.country_code}{driverInfo?.partner_info?.partner_secondary_mobile?.mobile_number}
                                    </p> */}

                                    {/* Payment Details */}
                                    <div className="bg-slate-50 p-4 mt-2 rounded-lg">
                                        <h1 className='font-semibold mb-4'>Driver Info.</h1>
                                        <div className='space-y-3'>
                                            <div className='flex justify-between text-sm'>
                                                <p className='text-slate-500 text-xs content-center font-semibold'>Driver Name:</p>
                                                {driverInfo?.partner_info?.name ? <p className='text-semibold'>{driverInfo?.partner_info?.name}</p> :
                                                    <p className='text-semibold'>------</p>}
                                            </div>
                                            <div className='flex justify-between text-sm content-center'>
                                                <p className='text-slate-500 text-xs font-semibold'>Vehicle No.</p>
                                                {driverInfo?.partner_info?.vehicle_number ? <p className='text-semibold'> {driverInfo?.partner_info?.vehicle_type} : {driverInfo?.partner_info?.vehicle_number}</p> :
                                                    <p className='text-semibold'>------</p>
                                                }
                                            </div>
                                            <div className='flex justify-between text-sm content-center'>
                                                <p className='text-slate-500 text-xs font-semibold'>Contact No.</p>
                                                {driverInfo?.partner_info?.mobile?.mobile_number ? <p className='text-semibold'>{driverInfo?.partner_info?.mobile?.mobile_number}</p> :
                                                    <p className='text-semibold'>------</p>}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* </div> */}


                            <div className='space-y-4'>
                                <p className='text-md font-semibold'>Address Details </p>
                                <div className='flex space-x-4'>
                                    <div className='space-y-1 text-gray-400'>
                                        <GoCircle />
                                        <ul className='ms-1.5'>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3'>I</li>
                                            <li className='text-xs leading-3 sm:hidden'>I</li>
                                            <li className='text-xs leading-3 sm:hidden'>I</li>
                                        </ul>
                                        <SlLocationPin />
                                    </div>
                                    <div className='space-y-4 truncate'>
                                        <div>
                                            <p className='text-sm font-semibold mb-1'>{showData?.addOrderForSameDay?.data?.pickup_details?.address?.contact_details?.name} <span className='ms-1 text-gray-400'>(Pickup)</span></p>
                                            <p className='text-sm text-gray-500'>{showData?.addOrderForSameDay?.data?.pickup_details?.address?.street_address1}</p>

                                            <p className='text-sm text-gray-500'>{showData?.addOrderForSameDay?.data?.pickup_details?.address?.contact_details?.phone_number}</p>
                                        </div>
                                        <div>
                                            <p className='text-sm font-semibold mb-1'>{showData?.addOrderForSameDay?.data?.drop_details?.address?.contact_details?.name} <span className='ms-1 text-gray-400'>(delivery)</span></p>
                                            <p className='text-sm text-gray-500'>{showData?.addOrderForSameDay?.data?.drop_details?.address?.street_address1}</p>
                                            {/* <p className='text-sm text-gray-500'>surat. gujrat - 567786</p> */}
                                            <p className='text-sm text-gray-500'>{showData?.addOrderForSameDay?.data?.drop_details?.address?.contact_details?.phone_number}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <p className='border border-slate-100'></p>


                            <div className='md:px-0 px-0'>
                                <PriceCalculator orderAmount={Math.round(showData?.addOrderForSameDay?.order_amount)} paymentModal='true' />

                            </div>
                            {/* <div className='space-y-2'>
                                <p className='font-semibold'>Size</p>
                                <div className='text-sm font-semibold flex justify-between'>
                                    <p className='text-gray-500'>Weight (KG)</p>
                                    <div className='flex'>
                                        <p className='me-4 text-slate-500 self-center text-lg'><RiWeightLine /></p>
                                        <p>9 Kg</p>
                                    </div>
                                </div>
                            </div> */}
                            {/* <p className='border border-slate-100'></p> */}
                            <div className="space-y-4">
                                {/* Title */}
                                <p className="text-md font-semibold">
                                    Two-Wheelers: The Smart Choice for Intra-City Logistics
                                </p>

                                {/* Product Value Section */}
                                <div className="flex justify-between">
                                    <div className='flex space-x-3'>
                                        <MdDirectionsBike className="text-3xl" />
                                        <p className='mt-0.5 font-semibold'>20 KG</p>
                                    </div>
                                    <div>
                                        <p className='text-center font-semibold'>2 Wheeler</p>
                                        <p className='text-sm'>45cm x 45cm x 45cm</p>
                                    </div>
                                </div>
                            </div>

                            {/* <p className='border border-slate-100'></p> */}

                            {/* <div className=''>
                                <p className='text-md font-semibold pb-4'>Price Details</p>
                                <div className='space-y-3'>
                                    <div className='flex justify-between text-sm md:font-semibold '>
                                        <p className='text-gray-500'>Total price</p>
                                        <p className=''>+ ₹{showData?.addOrderForSameDay?.order_amount}</p>
                                    </div>
                                    <div className='flex justify-between text-sm md:font-semibold'>
                                        <p className='text-gray-500'>Pickup Charge</p>
                                        <div className='flex gap-x-1'>
                                            <p className='line-through'>₹40</p>
                                            <p className='text-green-500'>Free</p>
                                        </div>
                                    </div>
                                    <div className='flex justify-between text-sm md:font-semibold'>
                                        <p className='text-gray-500'>Handling Fee</p>
                                        <div className='flex gap-x-1'>
                                            <p className='line-through'>₹00</p>
                                            <p className='text-green-500'>Free</p>
                                        </div>
                                    </div>
                                    <div className='flex justify-between text-sm md:font-semibold'>
                                        <p className='text-gray-500'>Total Discounts</p>
                                        <div className='flex space-x-3'>
                                            <p>- ₹00 </p>
                                            <p className='text-gray-500'>%99 off</p>
                                        </div>
                                    </div>
                                    <p className='border'></p>
                                    <div className='flex justify-between text-sm md:font-semibold'>
                                        <p>Total Amount</p>
                                        <p>₹899</p>
                                    </div>
                                  
                                </div>
                            </div> */}

                            {/* <div className=" p-6 bg-slate-50 border border-gray-200 rounded-lg shadow-sm"> */}
                            <h2 className="font-semibold text-gray-800 mb-4">Read before Booking</h2>
                            <ul className="list-disc pl-5 text-sm space-y-2 text-gray-700">
                                <li>
                                    <span className="font-medium">Fare includes</span> 25 mins free loading/unloading time.
                                </li>
                                <li>
                                    ₹2.0/min for additional loading/unloading time.
                                </li>
                                <li>
                                    Fare may change if route or location changes.
                                </li>
                                <li>
                                    Parking charges to be paid by the customer.
                                </li>
                                <li>
                                    Fare includes toll and permit charges, if any.
                                </li>
                                <li>
                                    We don’t allow overloading.
                                </li>
                            </ul>
                            {/* </div> */}
                        </div>

                        <div className="sticky bottom-0 bg-slate-50 border-t border-gray-200 pt-3 pb-4">
                            <div className="flex justify-between text-sm md:font-semibold px-4 md:px-6">
                                <p className="text-xl font-semibold">Total Amount</p>
                                <p className="text-xl font-semibold"> ₹{Math.round(showData?.addOrderForSameDay?.order_amount)}</p>
                            </div>
                            <div className="mt-4 sm:flex sm:flex-row-reverse px-4 sm:px-6">
                                {/* <button
                                    type="button"
                                    onClick={() => { paymentOrder() }}
                                    className="inline-flex w-full justify-center rounded-md bg-slate-800 px-20 py-2 text-sm font-semibold text-white shadow-sm hover:bg-slate-900 sm:ml-3 sm:w-auto"
                                >
                                    PAY ₹{(showData?.addOrderForSameDay?.order_amount / 100).toFixed(2)} {isLoading && <SpinLoader />}
                                    <SpinLoader />

                                </button> */}
                                {/* <button
                                    type="button"
                                    onClick={paymentOrder}
                                    disabled={!isTimerActive || isLoading}
                                    className={`inline-flex w-full justify-center rounded-md px-20 py-2 text-sm font-semibold shadow-sm sm:ml-3 sm:w-auto ${!isTimerActive || isLoading
                                        ? "bg-slate-400 text-gray-700 cursor-not-allowed"
                                        : "bg-slate-800 text-white hover:bg-slate-900"
                                        }`}
                                >
                                    PAY ₹{(showData?.addOrderForSameDay?.order_amount / 100).toFixed(2)}
                                    {/* {isLoading && <SpinLoader />} */}
                                {/* </button> */}
                                <button
                                    type="button"
                                    onClick={paymentOrder}
                                    disabled={!driverInfo || driverInfo?.status !== 'accepted' || timer === 0} // Adjusted condition
                                    className={`inline-flex w-full justify-center rounded-md px-20 py-2 text-sm font-semibold shadow-sm sm:ml-3 sm:w-auto ${driverInfo?.status !== 'accepted' || timer === 0
                                        ? "bg-slate-400 text-gray-700 cursor-not-allowed"
                                        : "bg-slate-800 text-white hover:bg-slate-900"
                                        }`}
                                >
                                    PAY ₹{Math.round(showData?.addOrderForSameDay?.order_amount)} to Continue
                                </button>

                                {/* <button
                                    type="button"
                                    onClick={paymentOrder}
                                    disabled={driverInfo?.data?.status !== 'accepted'}
                                    className={`inline-flex w-full justify-center rounded-md px-20 py-2 text-sm font-semibold shadow-sm sm:ml-3 sm:w-auto ${isButtonDisabled
                                        ? "bg-slate-400 text-gray-700 cursor-not-allowed"
                                        : "bg-slate-800 text-white hover:bg-slate-900"
                                        }`}
                                >
                                    PAY ₹{Math.round(showData?.addOrderForSameDay?.order_amount / 100)}
                                    {/* {isLoading && <span className="loader">Loading...</span>} */}
                                {/* </button> */}
                                {/* {isTimerActive && (
                                    <p className="text-gray-500 mt-2 text-sm">
                                        Complete the payment in <strong>{formattedTime}</strong>.
                                    </p>
                                )}
                                {!isTimerActive && (
                                    <p className="text-red-500 mt-2 text-sm">
                                        The payment session has expired. Please refresh to try again.
                                    </p>
                                )} */}
                                <button
                                    type="button"
                                    // onClose={setOpen}
                                    // onClick={() => { cancelorder() }}
                                    onClick={() => handleCancelOrder()}
                                    className="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-slate-50 sm:mt-0 sm:w-auto"
                                >
                                    Cancel Order
                                </button>
                            </div>
                        </div>
                    </DialogPanel>
                </div>
            </div>
        </Dialog>
    )
}

